import React from 'react';

import Flex from '../Flex';

export function CardBody({ className = '', children = null }) {
  return (
    <Flex
      direction="column"
      gap={16}
      className={className}
      data-card-element="body"
    >
      {children}
    </Flex>
  );
}
